export default __webpack_public_path__ + "images/KE.092e0b4.png";